export default "__VITE_ASSET__CEfbDqwo__"